import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { useConvex } from 'convex/react';
import { useState } from 'react';
import { MenuRearrangeList } from '@/routes/restaurant/menu/MenuRearrangeList';
import { useMenu } from '@/routes/restaurant/useRestaurantData';
import { CategoriesTable } from './CategoriesTable';

export const Route = createFileRoute('/r/$restaurantId/menu/categories')({
  component: CategoryListPage,
});

function CategoryListPage() {
  const convex = useConvex();
  const menu = useMenu();
  const [isRearranging, setIsRearranging] = useState(false);

  if (menu === null) {
    return null; // Handled by menu items tab
  }

  return (
    <div className={'xl:w-2/3'}>
      {isRearranging ? (
        <MenuRearrangeList
          items={menu.categories}
          itemsLabel="categories"
          onRearrangingDone={() => setIsRearranging(false)}
          onSave={(sortedCategoryUuids) =>
            convex.mutation(api.menus.updateCategoriesSortOrder, {
              menuId: menu._id,
              sortedCategoryUuids,
            })
          }
        />
      ) : (
        <CategoriesTable
          categories={menu.categories}
          menuId={menu._id}
          menuItems={menu.menuItems}
          onRearrange={() => setIsRearranging(true)}
        />
      )}
    </div>
  );
}
